// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeInviteAcceptBody = {
  inviteId: string;
};

export type typeInviteAcceptOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    outcome: "joined" | "pendingApproval" | "alreadyMember" | "unavailable";
    poolId: string;
    unavailableReason?: "revoked" | "full" | "closed" | null;
  };
};

export type typeInviteAcceptOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteAcceptOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteAcceptOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaInviteAcceptBody = {
  type: "object",
  properties: { inviteId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["inviteId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createInviteAccept(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaInviteAcceptBody);
  }

  return async function postInviteAccept(
    payload: typeInviteAcceptBody,
  ): Promise<typeInviteAcceptOutput200 | typeInviteAcceptOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postInviteAccept" failed before calling the network. #804ae64ac132`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#804ae64ac132" },
        },
        data: null,
      } as typeInviteAcceptOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/invite/accept`,
      httpMethod: "POST",
      options,
    })) as typeInviteAcceptOutput200 | typeInviteAcceptOutput400;
  };
}
